'use client';

import { Tabs as BaseTabs, TabsContent, TabsList, TabsTrigger } from '@/components/tabs/Tabs';
import baseTabsStyles from '@/components/tabs/Tabs.module.scss';
import type { ComponentTabsStoryblok, PartialTabStoryblok } from '@/types/component-types-sb';
import { StoryblokServerComponent } from '@storyblok/react/rsc';
import classNames from 'classnames';
import { type FC, useState } from 'react';

import { a11yProps } from './TabPanel';
import classes from './Tabs.module.scss';

export type { TabPanelProps } from './TabPanel';
export { TabPanel as Panel, a11yProps } from './TabPanel';

const Tabs: FC<{
  blok: ComponentTabsStoryblok;
}> = ({ blok }) => {
  const firstTabId = blok.tabs?.[0]?._uid;
  const [tab, setTab] = useState(firstTabId);

  if (!blok.tabs?.length || !firstTabId) {
    return null;
  }

  return (
    <div className={classes.tabs} id={blok.anchor || undefined}>
      <BaseTabs
        onValueChange={(value) => {
          if (value != null) {
            setTab(value);
          }
        }}
        value={tab}
      >
        <TabsList scrollable variant="default">
          {blok.tabs.map((tabItem: PartialTabStoryblok) => (
            <TabsTrigger key={`tab-${tabItem._uid}`} value={tabItem._uid} {...a11yProps(tabItem._uid)}>
              {tabItem.title}
            </TabsTrigger>
          ))}
        </TabsList>
        {blok.tabs.map((t: PartialTabStoryblok) => (
          <TabsContent
            key={`tab-panel-${t._uid}`}
            aria-labelledby={`tab-${t._uid}`}
            className={classNames(baseTabsStyles.content, 'tabPanel', classes.tabPanel)}
            data-testid={`tab-panel-${t._uid}`}
            id={`tab-panel-${t._uid}`}
            role="tabpanel"
            value={t._uid}
          >
            {t.body?.map((child) => (
              <StoryblokServerComponent blok={child} key={`tab-${child._uid}`} />
            ))}
          </TabsContent>
        ))}
      </BaseTabs>
    </div>
  );
};

export default Tabs;
